// src/components/TermsOfService.jsx
import React, { useEffect } from "react";
import "./TermsOfService.css";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="tos-container">
      <header className="tos-header">
        <h1>Términos de Servicio</h1>
        <p className="tos-updated">Última actualización: 27 de Junio de 2025</p>
      </header>

      {/* <section className="tos-intro">
        <p>
          Al acceder o utilizar <strong>ZY</strong> (“el Servicio”), aceptas
          estos Términos de Servicio (“Términos”). Si no estás de acuerdo, por
          favor no uses la plataforma.
        </p>
      </section> */}

      <section className="tos-section">
        {/* <h2>Responsable &amp; Estado Legal</h2> */}
        <p>
          <strong>Responsable del Servicio:</strong> Equipo fundador de ZY.
          <br />
          <strong>Estado legal actual:</strong> Proyecto en fase operativa; en
          proceso de incorporación legal en EE.UU.
        </p>
      </section>

      <section className="tos-section">
        <h2>1. Aceptación de los términos</h2>
        <p>
          Al acceder o utilizar ZY ("el Servicio"), aceptas estos Términos de
          Servicio ("Términos"). Si no estás de acuerdo con ellos, por favor no
          uses la plataforma.
        </p>
        <p>
          ZY se reserva el derecho de actualizar o modificar estos términos en
          cualquier momento. En caso de hacerlo, se notificará a los usuarios
          por medios razonables como correo electrónico, notificaciones en la
          app o redes sociales.
        </p>
      </section>

      <section className="tos-section">
        <h2>2. Estado legal de ZY</h2>
        <p>
          ZY es una iniciativa en etapa de crecimiento impulsada por un equipo
          fundador que opera desde Latinoamérica. Actualmente estamos en proceso
          de constitución como entidad legal en Estados Unidos, con el objetivo
          de fortalecer nuestra operación, garantizar cumplimiento normativo y
          brindar mayor confianza a nuestros usuarios y aliados.
        </p>
        <p>
          Hasta entonces, los servicios se ofrecen bajo un esquema pre-operativo
          de responsabilidad directa por parte del equipo fundador.
        </p>
      </section>

      <section className="tos-section">
        <h2>3. Quién puede usar ZY</h2>
        <p>
          ZY está diseñado para personas mayores de 18 años en América Latina
          que deseen mejorar su organización financiera, aplicar a oportunidades
          educativas, o crecer personal y profesionalmente. Al registrarte,
          confirmas que:
        </p>
        <ul>
          <li>Eres mayor de edad en tu país de residencia.</li>
          <li>La información proporcionada es verídica.</li>
          <li>Eres responsable del uso de tu cuenta.</li>
        </ul>
      </section>

      <section className="tos-section">
        <h2>4. Qué ofrece ZY</h2>
        <p>ZY proporciona herramientas y recursos como:</p>
        <ul>
          <li>Acceso a becas activas en México y el extranjero.</li>
          <li>
            Herramientas para rastrear gastos, establecer metas y ahorrar.
          </li>
          <li>
            Contenido educativo (actual y futuro) para desarrollo financiero y
            profesional.
          </li>
          <li>
            Una comunidad de usuarios que comparten recursos y oportunidades.
          </li>
          <li>
            Funcionalidades gratuitas y otras de tipo premium (opcionales y
            accesibles).
          </li>
        </ul>
      </section>

      <section className="tos-section">
        <h2>5. Uso permitido y prohibido</h2>
        <p>Puedes usar ZY para:</p>
        <ul>
          <li>Buscar becas y recursos formativos.</li>
          <li>Acceder a contenido educativo y herramientas financieras.</li>
          <li>Participar en la comunidad con respeto y honestidad.</li>
        </ul>
        <p>No puedes usar ZY para:</p>
        <ul>
          <li>Compartir contenido ofensivo, engañoso o ilegal.</li>
          <li>Realizar spam o promociones sin autorización.</li>
          <li>Suplantar identidades o vulnerar derechos de otros usuarios.</li>
          <li>Obtener ventajas indebidas a costa de la comunidad.</li>
        </ul>
      </section>

      <section className="tos-section">
        <h2>6. Registro y seguridad</h2>
        <p>Al crear una cuenta, te comprometes a:</p>
        <ul>
          <li>Proporcionar datos reales y actualizados.</li>
          <li>Mantener seguras tus credenciales de acceso.</li>
          <li>
            Asumir responsabilidad por cualquier actividad realizada desde tu
            cuenta.
          </li>
        </ul>
        <p>
          ZY puede suspender cuentas si detecta actividad fraudulenta o uso
          indebido del servicio.
        </p>
      </section>

      <section className="tos-section">
        <h2>7. Costos y Pagos</h2>
        <p>
          La mayoría de las funcionalidades de ZY son gratuitas. Algunas
          características futuras (como asesorías, automatización de ahorros o
          revisión de CVs) serán de pago, pero siempre:
        </p>
        <ul>
          <li>Claramente identificadas dentro de la plataforma.</li>
          <li>Opcionales y de bajo costo.</li>
          <li>Pagaderas en MXN o USD a través de pasarelas seguras.</li>
        </ul>
      </section>

      <section className="tos-section">
        <h2>8. Propiedad intelectual</h2>
        <p>
          Todo el contenido, diseño, marca, herramientas y funcionalidad de ZY
          son propiedad de sus creadores o licenciantes. No está permitido:
        </p>
        <ul>
          <li>Copiar, reproducir o distribuir contenido sin autorización.</li>
          <li>
            Utilizar elementos de ZY con fines comerciales sin permiso expreso.
          </li>
        </ul>
      </section>

      <section className="tos-section">
        <h2>9. Privacidad y datos</h2>
        <p>Tu privacidad es muy importante. Te garantizamos que:</p>
        <ul>
          <li>
            No vendemos ni compartimos tus datos con terceros para fines
            publicitarios.
          </li>
          <li>
            Solo usamos tu información para personalizar y mejorar tu
            experiencia.
          </li>
          <li>
            Puedes solicitar modificar o eliminar tus datos en cualquier
            momento.
          </li>
        </ul>
        Consulta nuestra{" "}
        <Link to="/politica-de-privacidad">Política de Privacidad</Link> para
        más detalles.
      </section>

      <section className="tos-section">
        <h2>10. Comunidad y conducta</h2>
        <p>Al interactuar con la comunidad de ZY:</p>
        <ul>
          <li>Sé respetuoso/a con otros usuarios.</li>
          <li>
            No compartas información falsa ni hagas afirmaciones engañosas.
          </li>
          <li>
            No realices actividades ilegales ni promuevas conductas nocivas.
          </li>
        </ul>
        <p>
          ZY se reserva el derecho de moderar contenido y suspender usuarios si
          es necesario.
        </p>
      </section>

      <section className="tos-section">
        <h2>11. Disponibilidad del servicio</h2>
        <p>
          ZY se encuentra en evolución. Por eso, podemos modificar, actualizar o
          eliminar funcionalidades sin previo aviso. Aunque trabajamos para
          ofrecer estabilidad, no garantizamos disponibilidad permanente.
        </p>
      </section>

      <section className="tos-section">
        <h2>12. Cancelación de cuenta</h2>
        <p>
          Puedes eliminar tu cuenta cuando quieras. El equipo de ZY también
          puede suspender tu acceso si detecta violaciones a estos Términos.
        </p>
      </section>

      <section className="tos-section">
        <h2>13. Limitación de responsabilidad</h2>
        <p>
          ZY busca ofrecer contenidos útiles y confiables, pero no garantiza
          resultados. El uso de la plataforma es bajo tu propio riesgo. En
          ningún caso ZY será responsable de:
        </p>
        <ul>
          <li>
            Pérdidas económicas, académicas o personales derivadas del uso de la
            app.
          </li>
          <li>La precisión o vigencia de becas y oportunidades externas.</li>
          <li>Decisiones que tomes a partir de la información ofrecida.</li>
        </ul>
      </section>

      <section className="tos-section">
        <h2>14. Actualizaciones a estos términos</h2>
        <p>
          Estos Términos pueden actualizarse en función del crecimiento de la
          plataforma o cambios legales. Te informaremos de cualquier
          modificación importante. El uso continuo del servicio implica la
          aceptación de los nuevos términos.
        </p>
      </section>

      <section className="tos-section">
        <h2>15. Contacto</h2>
        <p>Para dudas, sugerencias o soporte, puedes:</p>
        <p>
          📧 Enviar tu consulta en <Link to="/contacto">Contacto</Link> .
        </p>
        <p>💬 También puedes encontrarnos en nuestras redes sociales</p>
      </section>

      <footer className="tos-footer">
        <p>Nota legal complementaria:</p>
        <p>
          ZY App es un proyecto pre-incorporado. Se encuentra en proceso de
          formalización como entidad legal en EE.UU. El equipo fundador asume
          plena responsabilidad operativa hasta que la incorporación se
          concrete.
        </p>
      </footer>
    </main>
  );
}
